import { createContext } from 'react';

const FoodsContext = createContext();

export default FoodsContext;
